import {WINDOW_EVENTS} from "./window_events";
import {promise_timeout} from "../../lib/promise";

const ALL_WINDOWS = {};
let APP_INSTANCE;

const popup_center = (url, title, width, height) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

  const viewport_width = window.innerWidth
    ? window.innerWidth : document.documentElement.clientWidth
      ? document.documentElement.clientWidth : window.screen.width;
  const viewport_height = window.innerHeight
    ? window.innerHeight : document.documentElement.clientHeight
      ? document.documentElement.clientHeight : window.screen.height;

  const systemZoom = viewport_width / window.screen.availWidth;
  const left = (viewport_width - width) / 2 / systemZoom + dualScreenLeft * 0;
  const top = (viewport_height - height) / 2 / systemZoom + dualScreenTop * 0;
  const newWindow = window.open(url, title,
    `
      scrollbars=yes,
      width=${width / systemZoom}, 
      height=${height / systemZoom}, 
      top=${top}, 
      left=${left}`
  )

  if (window.focus)
    newWindow.focus();
  return newWindow;
}

const create_popup_window = (origin, url, window_id, width, height) => {
  const result = popup_center(url, window_id, width, height);
  ALL_WINDOWS[window_id] = result;

  result.addEventListener("message", APP_INSTANCE.onMessage, false);

  promise_timeout(2000)
    .then(() => {
      result.postMessage({
        source: WINDOW_EVENTS.CA_APP_PARENT,
        hasParent: true,
      }, origin);
    });
  return result;
}

const get_popup_window = window_id => {
  return ALL_WINDOWS[window_id];
}

const prune_closed_windows = () => {
  const win_list = Object.keys(ALL_WINDOWS);
  win_list.forEach(win_id => {
    if (ALL_WINDOWS[win_id].closed) {
      delete ALL_WINDOWS[win_id];
    }
  })
}

const close_all_popup_windows = () => {
  const ids = Object.keys(ALL_WINDOWS);
  ids.forEach(win_id => {
    ALL_WINDOWS[win_id].close();
    delete ALL_WINDOWS[win_id];
  })
}

// Sends message to all popup windows that aren't closed.
const broadcast_message = (msg, origin) => {
  prune_closed_windows();
  Object.values(ALL_WINDOWS).forEach(win => {
    console.log("post_message", msg, "to", win);
    win.postMessage(msg, origin);
  });
}

const set_app_instance = (app) => {
  APP_INSTANCE = app;
}

export { create_popup_window, broadcast_message, set_app_instance,
  get_popup_window, close_all_popup_windows };
